<script lang="ts">
	import { beforeNavigate } from '$app/navigation';
	import { createCollapsible, melt } from '@melt-ui/svelte';
	import { ChevronDown, ChevronUp } from 'lucide-svelte';
	import type { Snippet } from 'svelte';
	import { writable, type Writable } from 'svelte/store';
	import { slide } from 'svelte/transition';

	interface Props {
		title?: string;
		open?: Writable<boolean>;
		children?: Snippet;
	}

	let { title = 'Filter', open: customOpen = writable(false), children }: Props = $props();

	const {
		elements: { root, content, trigger },
		states: { open }
	} = createCollapsible({
		open: customOpen
	});

	beforeNavigate(() => {
		$open = false;
	});
</script>

<div use:melt={$root} class="relative text-black">
	<button
		use:melt={$trigger}
		class="index-bold bg-white-chocolate relative flex items-center rounded-2xl px-3 py-1 data-[state=open]:rounded-b-none"
		>{title}
		{#if $open}
			<ChevronUp class="w-4" />
		{:else}
			<ChevronDown class="w-4" />
		{/if}
	</button>

	{#if $open}
		<div
			use:melt={$content}
			transition:slide
			class="bg-white-chocolate absolute top-full right-0 z-10 -translate-y-1 rounded-tl-2xl rounded-b-2xl p-4"
		>
			{@render children?.()}
		</div>
	{/if}
</div>

<style lang="postcss">
	@reference '../app.css';

	.open {
		@apply z-20 rounded-b-none;
	}
</style>
